<div class="about-container">

    <div class="left">
      <div class="about-section">
        <h4 class="title"> {{aboutIntro[0]?.title}}</h4>
        <h4 style="color: #005eb8; font-weight: bold !important; font-size: 25px !important;"> {{aboutIntro[2]?.title}}</h4>
        <p  [innerHtml]="aboutIntro[0]?.description"></p>
         <p style="text-align: right;font-size: smaller !important;margin-top: -25px;" [innerHtml]="aboutIntro[1]?.description"></p>
       </div>
    </div>
 
     
 
    <div class="right">
      <h4 style="margin-top: 90px;color: #005eb8;margin-bottom: -10px; font-size: 25px !important;font-weight: bold !important;">{{aboutCommercial[0]?.title}}</h4>
      <div class="top-row" *ngIf="aboutCommercial.length>0 ">
         <div class="commercial-card">
          <div class="sub-commercial-card">
          <div  *ngIf="aboutCommercial.length>0 ">
            <h4 class="title-color" style="margin-left: 10px;margin-top: 5px;">{{aboutCommercial[0]?.description}}</h4>
          </div>
              <div class="sub-item" *ngFor="let about of  aboutCommercial.slice(1); let i=index">
                <div class="sub-item-content">
                  <img class="image-content img-{{i}}" src="{{about.mediaUrl}}" alt="{{about.title}}">
                   <h4 style=" margin-top: 10px;">{{about?.title}}</h4>
                    <p  [innerHtml]="about.description"></p>
                 <a  *ngIf="about.Button" (click)="navigateToTargetLink(about);" class="btn">{{about.Button}}
                  <img src="../../../../assets/images/Major/Arrow_right_btn_icon.png" />
                  </a>
              </div>
              </div>
          </div>
          </div>
   
          <div class="consumer-section">
              <ng-container *ngFor="let about of aboutConsumer; let i= index">
                  <div class="consumer-card">
                      <h4 class="title-color" >{{ aboutConsumerTitle[0]?.title}}</h4>
                      <img class="consumer-img" src="{{about.mediaUrl}}" alt="{{about.title}}">
                      <h3 style=" margin-top: 3px;font-weight: bold">{{about?.title}}</h3>
                     <p [innerHtml]="about.description"></p>
                      <a  *ngIf="about.Button" (click)="navigateToTargetLink(about);" class="button">{{about.Button}}
                        <img src="../../../../assets/images/Major/Arrow_right_btn_icon.png" />
                      </a>
                  </div>
              </ng-container>
              <ng-container  *ngIf="aboutConsumerImages.length > 0">
                  <div class="contact-card">
                    <ng-container *ngFor="let about of aboutConsumerImages">
                    <img src="{{about.mediaUrl}}" alt="{{about.title}}">
                    <p [innerHtml]="about?.description"></p>
                    <a  *ngIf="about.Button" (click)="navigateToTargetLink(about);" class="button">{{about.Button}}
                      <img src="../../../../assets/images/Major/Arrow_right_btn_icon.png" />
                    </a>
                    </ng-container>
                  </div>
              </ng-container>
          </div>
    </div>
   
    
 
</div>